// extracted by mini-css-extract-plugin
export var dropdown = "_r2-0";
export var imageWrapper = "_r2-3";
export var itemNameContainer = "_r2-1";
export var productImage = "_r2-2";
export var spinnerWrapper = "_r2-4";